import { createContext, RefObject } from 'react'

export interface ModalContextValue {
  /**
   * fullScreen
   */
  supportFullscreen?: boolean

  /**
   * logo
   */
  logo?: React.ReactNode

  /**
   * container ref
   */
  modalContainer?: RefObject<HTMLDivElement>
}

export const ModalContext = createContext<ModalContextValue>({})
